import React, { useState } from "react";

import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MemoizedMarkdown } from "../../../../../components/Markdown";
import { SaveOutputControl } from "./SaveOutputControl";

import type { AnswerOutput } from "../types";

// Direct text answer + a collapsible disclosure of what was actually computed. The disclosure
// is the trust anchor: the admin can always verify the query behind a stated number.
export const TextAnswerBubble: React.FC<{ output: AnswerOutput; messageId: string; defaultName: string }> = ({
	output,
	messageId,
	defaultName,
}) => {
	const [showQuery, setShowQuery] = useState(false);

	return (
		<div className="mt-1">
			<div className="flex items-start justify-between gap-2">
				<div className="min-w-0 flex-1">
					<MemoizedMarkdown
						content={output.answer}
						id={`${messageId}-answer`}
						disallowImages
						restrictExternalLinks
					/>
				</div>
				<SaveOutputControl output={output} defaultName={defaultName} />
			</div>
			{output.underlyingQuery && (
				<div className="mt-2">
					<button
						type="button"
						onClick={() => setShowQuery((open) => !open)}
						className="flex items-center gap-1.5 text-xs text-neutral-500 hover:text-neutral-700"
						aria-expanded={showQuery}
					>
						<FontAwesomeIcon
							icon={faChevronRight}
							className={`text-[10px] transition-transform ${showQuery ? "rotate-90" : ""}`}
						/>
						<span>{showQuery ? "Hide" : "Show"} underlying query</span>
					</button>
					{showQuery && (
						<p className="mt-1.5 rounded border border-neutral-200 bg-neutral-50 px-3 py-2 text-xs text-neutral-600">
							{output.underlyingQuery}
						</p>
					)}
				</div>
			)}
		</div>
	);
};

export default TextAnswerBubble;
